(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["emailLonsdale"] && !Shopify.designMode) return;
  try {
    
document.documentElement.style.setProperty('--section-bg-{{ section.id }}', '{{ section.settings.background_color }}');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lonsdale-announcement-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lonsdale-announcement-bar')) {
  class LonsdaleAnnouncementBar extends HTMLElement {
    #items = [];
    #index = 0;
    #timer = 0;

    connectedCallback() {
      this.#items = Array.from(this.querySelectorAll('[data-lonsdale-ab-item]'));
      const activeIndex = this.#items.findIndex((item) => item.classList.contains('is-active'));
      this.#index = activeIndex > -1 ? activeIndex : 0;

      this.querySelector('[data-lonsdale-ab-close]')?.addEventListener('click', this.#dismiss);
      this.addEventListener('click', this.#onClick);
      this.addEventListener('mouseenter', this.#stop);
      this.addEventListener('mouseleave', this.#onMouseLeave);
      this.addEventListener('focusin', this.#stop);
      this.addEventListener('focusout', this.#onFocusOut);

      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:block:select', this.#onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.#onBlockDeselect);
      }

      this.#start();
    }

    disconnectedCallback() {
      this.#stop();
      document.removeEventListener('shopify:block:select', this.#onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.#onBlockDeselect);
    }

    #dismiss = () => {
      if (window.Shopify?.designMode) {
        this.hidden = true;
        return;
      }

      try {
        localStorage.setItem('lonsdale-ab-dismissed', this.dataset.dismissKey || '');
      } catch (error) {
        /* Storage can be blocked. The bar still hides for this view. */
      }

      document.documentElement.setAttribute('data-lonsdale-ab-dismissed', '');
    };

    #onClick = (event) => {
      const trigger = event.target.closest('[data-klaviyo-form]');
      if (!trigger || !this.contains(trigger)) return;
      event.preventDefault();
      const formId = trigger.getAttribute('data-klaviyo-form');
      if (!formId) return;
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    };

    #start = () => {
      if (this.#items.length < 2) return;
      this.#stop();
      const interval = Number(this.dataset.interval) || 3000;
      this.#timer = window.setInterval(() => {
        const next = (this.#index + 1) % this.#items.length;
        this.#show(next);
      }, interval);
    };

    #stop = () => {
      window.clearInterval(this.#timer);
      this.#timer = 0;
    };

    #onMouseLeave = () => {
      if (this.matches(':focus-within')) return;
      this.#start();
    };

    #onFocusOut = (event) => {
      if (this.contains(event.relatedTarget)) return;
      this.#start();
    };

    #onBlockSelect = (event) => {
      const item = event.target?.closest?.('[data-lonsdale-ab-item]');
      if (!item || !this.contains(item)) return;
      const index = this.#items.indexOf(item);
      if (index < 0) return;
      this.#stop();
      this.#show(index);
    };

    #onBlockDeselect = (event) => {
      const item = event.target?.closest?.('[data-lonsdale-ab-item]');
      if (!item || !this.contains(item)) return;
      this.#start();
    };

    #show(index) {
      const previous = this.#items[this.#index];
      const next = this.#items[index];
      if (previous && previous !== next) {
        previous.classList.remove('is-active');
        previous.setAttribute('aria-hidden', 'true');
        if (previous.matches('a, button')) previous.setAttribute('tabindex', '-1');
      }
      this.#index = index;
      if (!next) return;
      next.classList.add('is-active');
      next.removeAttribute('aria-hidden');
      next.removeAttribute('tabindex');
    }
  }

  customElements.define('lonsdale-announcement-bar', LonsdaleAnnouncementBar);
}

  } catch(e) { console.error(e); }
})();
})();
